<template>
    <div class="v-icon mr-2 ">
        <v-btn
            @click="editDialog(personId)"
            class="info"
        >
            Edit
        </v-btn>
        <v-dialog
            :value="editPersonTeamDialog"
            max-width="700px"
            persistent
        >
            <v-card v-if="editPersonTeamDialog">
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Edit Person Team</span>
                    <v-spacer />
                    <v-btn
                        @click.stop="closeEditItem()"
                        fab
                        rounded
                        small
                        text
                    >
                        X
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container
                        grid-list-md
                        pt-0
                    >
                        <v-layout wrap>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    :error-messages="editTeamIdErrors"
                                    :items="teamList"
                                    @blur="$v.editTeamId.$touch()"
                                    @input="$v.editTeamId.$touch()"
                                    item-text="name"
                                    item-value="teamId"
                                    label="Team"
                                    v-model="editTeamId"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveEditItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeEditItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
import EditTableFunctions from '../editTableFunctions';

    import { SET_EDIT_PERSON_FORM_SECTION_STATE } from "@/store/person/mutations";
import { FETCH_PERSON_TEAM, SAVE_PERSON_TEAM } from "@/store/person_team/actions.js";
import { LOAD_PERSON_TEAM_TO_EDIT, RESET_DEFAULT_PERSON_TEAM_TO_EDIT, TOGGLE_EDIT_PERSON_TEAM_DIALOG, UPDATE_PERSON_TEAM_FIELD } from "@/store/person_team/mutations.js";

    import { helpers, required } from 'vuelidate/lib/validators';

    // eslint-disable-next-line
    const phone = helpers.regex('alpha', /^(\+\s?)?((^\+.*)\(\+?\d+([\s\-\.]?\d+)?\)|\d+)([\s\-\.]?(\(\d+([\s\-\.]?\d+)?\)|\d+))*(\s?(x|ext\.?)\s?\d+)?$/);

    export default {
        name: "EditPersonTeamDialog",

        validations: {
            editTeamId: {required},
        },

        components: {},

        mixins: [
            EditTableFunctions,
        ],

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                // Required for editTableFunctions
                idName: 'personTeamId',
            }
        },

        computed: {
            editTeamId: {
                get() {
                    return this.$store.state.person_team.editPersonTeam.teamId;
                },
                set(value) {
                    this.updatePersonTeam('teamId', value);
                }
            },
            editTeamIdErrors() {
                const errors = [];
                if (!this.$v.editTeamId.$dirty) return errors;
                !this.$v.editTeamId.required && errors.push('required.');
                return errors
            },
            ...mapGetters(
            [
                "editPersonTeamDialog",
                "editFeedback",
                "statusList",
                "personnelCountryList",
                "applicationTypeNameById",
                "feedbackTypeNameById",
                "statusNameById",
                "editPersonFormState",
                "teamList",
            ]
            ),
            ...mapGetters({
                id: "editPersonTeamId"
            })
        },

        mounted() {
            //this.fetchPersonTeam();
        },


        methods: {
            validate() {

                this.$v.$touch();

                let formState = false;

                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }


                this.$store.commit(SET_EDIT_PERSON_FORM_SECTION_STATE, {section: 'team', state: formState});
            },

            async validateAll() {

                const results = Promise.all([
                    this.validate(),
                ]);

                await results;

                let resultsArray = [];

                resultsArray.push(this.editPersonFormState('team'));

                const areValid = resultsArray.every((result) => {
                    return result == 'complete';
                });

                return areValid;
            },

            fetchPersonTeam() {
                this.$store.dispatch(FETCH_PERSON_TEAM, this.personId);
            },

            updatePersonTeam(field, value) {
                let data = {};
                data.field = field;
                data.value = value;
                this.$store.commit(UPDATE_PERSON_TEAM_FIELD, data);
            },
            // updatePersonSummary() {
            //     this.$store.dispatch(UPDATE_PERSON_TEAM)
            // },
            toggleEditPersonSummaryDialog() {
                this.$store.commit(TOGGLE_EDIT_PERSON_TEAM_DIALOG);
            },
            ...mapActions({
                fetchItem: FETCH_PERSON_TEAM,
                updateTableItemRecord: SAVE_PERSON_TEAM,
            }),
            //
            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_TEAM_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_TEAM_TO_EDIT,
                // updateTableItemToEdit: ,
                resetEditItemToDefault: RESET_DEFAULT_PERSON_TEAM_TO_EDIT,
            }),

        },

    }
</script>

<style scoped>
</style>
